<template>
    <div>
        <span v-if="label" :class="['label', { 'bolder-label': bolderLabel }]">{{ label }}</span>
        <v-file-input :color="color" :outlined="outlined" :dense="dense" :hide-details="!showDetails"
            :disabled="disabled" :loading="loading" :placeholder="placeholder" @change="emitFile" :accept="mimeType" :clearable="false">
            <template v-slot:append v-if="canDelete">
                <v-icon @click.stop="deleteFile">mdi-close</v-icon>
            </template>
        </v-file-input>
    </div>
</template>

<script>
export default {
    name: "KimsaFile",
    props: {
        canDelete: {
            type: Boolean,
            default: false
        },
        label: {
            type: String,
            default: '',
        },
        color: {
            type: String,
            default: 'primary'
        },
        rules: {
            type: Array,
            default: () => []
        },
        placeholder: {
            type: String,
            default: ''
        },
        value: {
            type: [String, Number],
            default: '',
        },
        elevation: {
            type: Boolean,
            default: false,
        },
        showDetails: {
            type: Boolean,
            default: false,
        },
        disabled: {
            type: Boolean,
            default: false
        },
        outlined: {
            type: Boolean,
            default: false
        },
        dense: {
            type: Boolean,
            default: false
        },
        loading: {
            type: Boolean,
            default: false
        },
        bolderLabel: {
            type: Boolean,
            default: false
        },
        mimeType: {
            type: String,
            default: '*'
        }
    },
    data() {
        return {
            file: '',
        }
    },
    methods: {
        setDefaults() {
            const vm = this
            if (vm.value) {
                vm.file = vm.value
            }
        },
        reset() {
            const vm = this
            vm.file = ''
        },
        emitFile(file) {
            this.file = file
            this.$emit('change', this.file);
        },
        deleteFile() {
            this.file = null;
            this.$emit('change', null);
            this.$emit('delete');
        },
    },
    mounted() {
        const vm = this;
        vm.setDefaults()
    },
    watch: {
        value() {
            this.setDefaults()
        },
    }
}
</script>

<style scoped>
.label {
    font-size: 15px;
    color: #333333;
}

.bolder-label {
    font-weight: bold;
}
</style>